import { watch } from 'vue'
import { useAppStore } from '@/stores/app'

/**
 * Registra `callback` per quando cambia l'azienda corrente (id diverso dal precedente).
 * Punto unico per azzerare filtri, risultati e richieste in volo degli store dei report:
 * dopo il cambio, filtri e conti dell'azienda precedente sarebbero un 400 (o un report vuoto).
 * flush 'sync': il reset avviene prima di qualunque load lanciato subito dopo selectCompany.
 */
export function onCompanyChange(callback: () => void): void {
  const appStore = useAppStore()
  watch(
    () => appStore.currentCompany?.id,
    (id, previous) => {
      if (id !== previous) callback()
    },
    { flush: 'sync' }
  )
}
